import { ref, unref, watch } from "vue";
import { getTransactionLinks } from "@/entities/transaction/api";
import { extractItems } from "@/shared/serviceResponse";

export function useTransactionLinks(uuidRef) {
  const links = ref([]);
  const linksLoading = ref(false);

  async function fetchLinks() {
    const id = unref(uuidRef);
    if (!id) {
      links.value = [];
      return;
    }
    linksLoading.value = true;
    try {
      const data = await getTransactionLinks(id);
      if (data?.success) {
        links.value = extractItems(data.payload);
      } else {
        links.value = [];
      }
    } finally {
      linksLoading.value = false;
    }
  }

  watch(
    () => unref(uuidRef),
    (val) => {
      if (val) fetchLinks();
      else links.value = [];
    },
    { immediate: true }
  );

  return {
    links,
    linksLoading,
    fetchLinks,
  };
}
